import { Controller } from "@hotwired/stimulus"
import { post } from "@lib/requests"

// Connects to data-controller="user-history"
export default class extends Controller {
  
  connect() {
    // When connecting, we send through the current URL to the server to update the user's history.
    // Guard against turbo reconnects: only send when path changes, or after a short cooldown.
    try {
      const path = `${window.location.pathname}${window.location.search}`
      const storageKey = "user_history:last"
      const cooldownMs = 60_000

      const last = JSON.parse(sessionStorage.getItem(storageKey) || "{}")
      const lastPath = last?.path
      const lastAt = last?.at || 0
      const now = Date.now()

      const shouldSend = !lastPath || lastPath !== path || now - lastAt > cooldownMs
      if (!shouldSend) return

      sessionStorage.setItem(storageKey, JSON.stringify({ path, at: now }))
      post("/utilisateurs/historique", { responseKind: "json" })
    } catch (e) {
      // Storage can fail (Safari private mode). Fall back to a best-effort request.
      post("/utilisateurs/historique", { responseKind: "json" })
    }
  }

}
